export default {
  language: {
    'zh-cn': '中文（简体）',
    'en-us': '英语',
    'zh-tw': '中文（繁体）',
    'ru-ee': '东欧',
  },
  common: {
    cn: '中国',
    in: '印度',
    eu: '欧洲',
    accountSetting: '账户设置',
    passwordSetting: '密码设置',
    pi: '请输入{0}',
    ps: '请选择{0}',
    and: '和',
    account: '账号',
    verificationCode: '验证码',
    password: '密码',
    currentPassword: '当前密码',
    goLogin: '已有账号,去登录?',
    confirm: '确定',
    confirm2: '确认',
    cancel: '取消',
    confirmPassword: '确认密码',
    confirmSettings: '确认设置',
    newPassowrd: '新密码',
    userName: '用户名',
    dataCenter: '数据中心',
    appDownload: '移动端下载页',
    mail: '邮箱',
    europe: '欧洲',
    theUnitedStates: '美国',
    australia: '澳大利亚',
    china: '中国',
    india: '印度',
    phone: '手机号',
    len: '{0}长度至少为{1}个字符',
    registerSuccessConfirm: '注册成功,是否前往登录?',
    registerSuccessPLogin: '注册成功,请登录!',
    confirmDiff: '密码输入不一致',
    newPwdSame: '所设置的新密码不可与当前密码一致',
    newPwdDiff: '密码输入不一致',
    passwordFormatError: '8-16位, 至少包含数字、字母或符号中的两项或以上',
    phoneAndMailFormatError: '手机号码/邮箱格式错误',
    phoneFormatError: '手机号码格式错误',
    mailFormatError: '邮箱格式错误',
    successfully: '成功',
    fail: '失败',
    close: '关闭',
    operation: '操作',
    query: '查询',
    pageTotal: '共 {0} 条',
    pageTotal2: '共 {0} 台',
    tiao: '条',
    submit: '提交',
    min: '请输入不少于{0}个字符',
    max: '请输入少于{0}个字符',
    minMaxLimit: '请输入{0}-{1}个字符',
    basic: '基本',
    tag: 'TAG',
    device: '设备',
    alarm: '告警',
    screen: '组态画面',
    loginSuccessfully: '登录成功!',
    logoutSuccessfully: '退出登录成功!',
    read: '读',
    write: '写',
    readWrite: '读写',
    copy: '复制',
    edit: '编辑',
    delete: '删除',
    tip: '提示',
    updateSuccessfully: '更新成功!',
    alarmLevel1: '非常紧急',
    alarmLevel2: '普通',
    alarmLevel3: '比较紧急',
    online: '在线',
    offline: '离线',
    logout: '退出登录',
    settings: '设置',
    colorScheme: '配色方案',
    menuScheme: '菜单颜色',
    lightMode: '日间模式',
    darkMode: '夜间模式',
    light: '浅色',
    dark: '深色',
    operationSuccessfully: '操作成功!',
    valName: '变量名称',
    create: '创建',
    yes: '是',
    no: '否',
    getUserInfoFaild: '获取用户信息失败, 请重新登录!',
    switchToNew: '请完善用户基本信息',
    switchToNewMsg: '完善用户信息成功!',
    resetPassword: '重置密码',
    permission: '权限',
    roleName: '角色名称',
    unbindCurrDevice: '确定删除设备',
    unbindCurrDeviceMemo: '删除该设备后，监控该设备产生的数据将被删除且不可恢复',
    changePasswordSuccessfully: '修改密码成功, 请重新登录!',
    changeProfileSuccessfully: '修改用户信息成功!',
    noData: '暂无数据',
    backToLogin: '返回登录页',
    mailResultMemo1: '感谢注册！激活邮件已发送至您的邮箱：',
    mailResultMemo2: '请在48小时内登录邮箱，按照邮箱中的提示完成激活',
    mailResultMemo3: '没有收到验证码怎么办?',
    mailResultMemo4: '1、检查是否在邮件的广告邮件、垃圾邮件中',
    mailResultMemo5: '2、确认未收到邮件，请尝试',
    reSend: '重新发送',
    activeMail: '激活邮件',
    moveTo: '移动到...',
    groupPickerMemo1: '可移动到已创建的任一组级中',
    groupPickerMemo2: '请选择要放置的组级位置',
    deleteTemplate: '删除模板',
    deleteTemplateConfirm: '是否删除模板',
    deleteProject: '删除聚合项目',
    deleteProjectConfirm: '是否删除聚合项目',
    activeResult: '激活结果',
    dataCenterPickerMemo1: '您的设备数据将存储于所选的数据中心，请谨慎选择',
    templateLimit: '您的模板个数已达上限',
    modifySuccess: '修改成功',
    modifyFail: '修改失败',
    addSuccess: '添加成功',
    addFail: '添加失败',
    inputPositive: '请输入大于0的正整数',
    importLimit: '最多支持导入{0}条数据',
    disconnect: '断开',
    notCurrentDataCenter: '请选择当前数据中心',
    updateInProgress: '更新中, 请稍后',
    enableLocationPermission: '请开启浏览器定位权限',
  },
  login: {
    loginPlatform: '登录DIACloud云平台',
    account: '账号',
    password: '密码',
    rememberPassword: '记住密码',
    phoneAndMailAndUsername: '手机号码/邮箱',
    readAndAgree: '我已阅读并同意',
    serviceAgreement: '服务协议',
    privacyAgreement: '隐私政策',
    registerNow: '立即注册',
    forgotPassword: '忘记密码',
    login: '登录',
    goLogin: '前往登录',
    agreeMemo: '请阅读并同意服务协议与隐私政策',
    cookieTips1: '本网站使用cookies',
    cookieTips2: '我们使用cookies来改善您在网站上的体验，我们尊重您的选择，并致力于为您提供安全的浏览体验。',
    reject: '拒绝',
    accept: '接受',
  },
  register: {
    registerWay: '注册方式',
    register: '注册',
    phoneRegistration: '手机号注册',
    mailRegistration: '邮箱注册',
    submit: '提交注册',
    getVarifyCode: '获取验证码',
    second: '秒',
    sendToMuch: '发送次数过多',
    contactMemo: '用于消息设备-接收渠道信息,不用于账号登录',
  },
  dashboard: {
    operation: '运营管理',
    controlPanel: '仪表盘',
    dashboard: '数据看板',
    data: '数据',
    alarm: '告警',
    collectionEmpty: '暂无收藏设备',
    goto: '前往',
    download: '下载',
    favoriteDevice: '收藏设备',
    deviceOverview: '设备信息',
    hmiScreen: 'HMI屏',
    deviceState: '设备组态',
    projectState: '聚合组态',
    IndicatorCard: '指标卡',
    config: '组态画面',
    thumbnail: '缩略图',
    viewDcreen: '查看组态画面',
    editScreen: '编辑组态画面',
    configScreen: '组态画面',
    hmiBind: 'HMI信息',
    billingDetail: '计费详情',
    basicInfo: '基本信息',
    configUpdate: '组态信息',
    hmiScreenSN: 'HMI屏SN',
    hmiGatewaySN: 'HMI网关SN',
    deviceName: '设备名称',
    deviceSN: '设备SN',
    deviceModel: '设备型号',
    deviceGroup: '设备分组',
    relateTemplate: '关联模板',
    deviceAddress: '设备地址',
    remark: '备注',
    configCreate: '创建时间',
    configModify: '更新时间',
    maskSuccessfully: '收藏成功!',
    removeMaskSuccessfully: '取消收藏成功!',
    editModelMemo: '当前信息未保存,切换标注将会放弃所有修改数据?',
    notAssociated: '未关联',
    editScreenMsg1: '请使用 DIAWeb Designer 编辑画面',
    editScreenMsg2: '如果您的电脑未安装 DIAWeb Designer',
    please: '请',
    addComponent: '添加组件',
    selectDevice: '选择设备',
    selectProject: '选择聚合项目',
    noDevicePermission: '暂无该设备权限',
    noDeviceConfigPermission: '暂无该设备组态权限',
    noProjectPermission: '暂无该聚合项目权限',
    IndicatorCardName: '指标卡名称',
    dataSource: '数据来源',
    icon: '图标',
    deviceTotalNum: '设备总数',
    deviceOnline: '在线设备',
    deviceOffline: '离线设备',
    deviceFault: '故障设备',
    componentTitleInfo1: '（建议不超过3个）',
    compoentEmptyInfo1: '选择一个组件，开始搭建你的仪表盘',
  },
  device: {
    unBindDevice: '删除设备',
    unBindDeviceOk: '删除设备成功',
    deviceManage: '设备管理',
    deviceList: '设备列表',
    templateList: '单设备模板',
    deviceGroup: '设备分组',
    tunnel: 'Tunnel状态',
    groupSameName: '分组重名',
    rename: '重命名',
    addGroup: '添加分组',
    addChildGroup: '添加子分组',
    delete: '删除',
    deleteSucccessful: '删除{0}成功!',
    groupName: '分组名称',
    defaultGroup: '默认分组',
    setDefaultGroup: '设为默认分组',
    templateName: '模板名称',
    templateType: '模板类型',
    localTemplate: '本地模板',
    globalTemplate: '全球模板',
    dataCenter: '数据中心',
    hmiModel: 'HMI屏型号',
    deviceCount: '设备数量',
    publishTime: '创建时间',
    queryNamePh: '模板名称',
    queryModelPh: 'HMI屏型号',
    addTemplate: '添加模板',
    copyTemplate: '复制模板',
    deviceName: '设备名称',
    deviceSN: '设备SN',
    description: '客户名称',
    deviceModel: '设备型号',
    hmiScreenModel: 'HMI屏型号',
    cloneTemplate: '克隆模板',
    remark: '备注',
    templateInfo: '模板信息',
    hmiScreen: 'HMI屏',
    fw: '固件',
    recipe: '配方',
    versionNumber: '版本号',
    createTime: '创建时间',
    configurationState: '组态',
    configurationStateCreateTime: '组态创建时间',
    configurationStatemodifyTime: '组态修改时间',
    tagName: 'TAG名称',
    dataType: '数据类型',
    addrType: '地址类型',
    address: '地址',
    rwType: '读写类型',
    scanTime: '扫描时间',
    saveHistroy: '存历史',
    devTemProName: '设备名称/关联模板/关联聚合项目',
    hmiDongleState: 'HMI网关状态',
    hmiGraph: 'HMI画面',
    hmiDongleAsync: 'HMI与云端同步',
    deviceTag: '设备标注',
    tagEmpty1: '暂无标注,',
    createTag: '新建标注',
    editTag: '编辑标注',
    deleteTag: '删除标注',
    addTag: '添加标注',
    tagNumLimit: '标注上限50个',
    checkTagNumLimit: '选中标注上限10个',
    createAndSearchTag: '创建/搜索标注',
    addDevice: '添加设备',
    syncState1: '已同步',
    syncState0: '待同步',
    cloudLastVer: '云端最新版本',
    hmiThisVer: 'HMI版本',
    asyncTooltipTitle: 'HMI本地与云端配置同步情况(请前往HMI-系统更新,进行同步)',
    labelOver: '标注长度限制1-50个字符',
    labelSame: '标注名称已存在',
    labelNumLimit: '标注数量达到50个上限',
    deviceChangeGroup: '设备移组',
    changeGroupSuccessfully: '移组成功!',
    addModel: '新增型号',
    templateDesign: '组态设计',
    unbindLabel: '删除标注',
    unbindLabelConfirm: '删除该标注会同步删除其他设备已绑定的同名标注, 确定删除?',
    templateDesignConfirm: '是否编辑设备已加入的模板{0}?',

    projectlist: '聚合项目',
    costomName: '客户名称',
    groupCantRepeat: '分组名称不可重复',
    projectName: '名称',
    deleteProject: '删除',
    deleteProjectConfirm: '是否删除{0}',
    addProject: '新增',
    projectTips: '该聚合项目已过期，请激活Cloud Application计费卡',
    projectDetail: '基础信息',
    removeDev: '移除设备',
    removeDevConfirm: '是否移除设备{0}',
    relatDev: '关联设备',
    viewTag: '查看TAG',
    remove: '移除',
    assignGroupPm: '请分配设备分组权限',
    project: '聚合项目',
    assignProjectPm: '请分配聚合项目列表权限',
    usedTemplate: '模板引用',
    usedProject: '聚合项目引用',
    devNameTip: '设备名称请使用中文或者英文开头',
    devNameTip2: '设备名称只能包含：汉字、英文字母、数字、下划线',

    noTemplate: '暂未关联模板',
    noConfig: '所关联的模板暂未绘制组态画面',
    noSpace: '设备名称不能包含空格',
    noKeyword: '设备名称不能包含关键字',
    removeProjectInfo3: '3、未解绑全部聚合项目',

    alreadySelectDevice: '已选{0}台设备',

    deviceoverview: '设备总览',
    deviceTotal: '设备总数',
    monthIncrease: '较上月增长',
    monthDecrease: '较上月减少',
    deviceOnline: '在线设备',
    onlineRate: '在线率',
    deviceOffline: '离线设备',
    offlineRate: '离线率',
    deviceRegional: '设备地区分布',
    alarmLevel: '告警等级分布',
    level1: '轻微',
    level2: '较轻',
    level3: '一般',
    level4: '较重',
    level5: '严重',
    faultOverview: '故障概览',
    alarmNum: '告警数',
    responsesNum: '应答数',
    failRate: '设备故障率',
    global: '全球',
    comparedLastMonth: '较上月',
    lowSDKVersion: '当前HMI版本号过低，请将HMI升级至1.0.0.5及以上版本',
    addDatacenter: '新增数据中心',
    map: '地图',
    location: '定位',
  },
  template: {
    defaultValue: '默认值',
    description: '描述',
    templateMemo: '模板介绍',
    bindTemplateTip: '确定绑定模板',
    templateLockTip1: '该模板已过期，请激活Cloud Application计费卡，充值模板数量',
    templateLockTip2:
      'TIP: 激活Cloud Application计费卡后，从最近创建的模板开始恢复，请控制好您的模板总数，以免您需要的模板无法恢复使用',
  },
  message: {
    messageCenter: '消息中心',
    alarm: '告警',
    system: '系统公告',
    billingMsg: '计费消息',
    alarmMag: '告警记录',

    billingMsgType1: 'Remote Access到期提醒',
    billingMsgType2: 'Cloud Application到期提醒',
    billingMsgType3: '设备TAG到期提醒',
    billingMsgType4: '设备流量不足提醒',
    billingMsgType5: '账号TAG不足提醒',
    billingMsgType6: '邀请通知',
    billingMsgType7: '取消邀请提醒 ',
    billingMsgType8: '移出团队提醒',
    billingMsgType9: '主账号转让通知',

    readAllTip: '已全部标记已读',
    total: '全部',
    unread: '未读',
    msgType: '消息类型',
    startDate: '选择开始时间',
    endDate: '选择结束时间',
    readAll: '全部已读',
    billing: '计费',
    notifications: '公告',
    warnings: '告警',
    noUnread: '暂无消息',
    noUnreadToday: '暂无未读消息',
    goAllMsg: '查看全部',
    monthTraffic: '本月消耗流量',
    open: '已开启',
    close: '已关闭',
    continued: '继续使用',
    closeTraffic: '关闭流量',
    todayNews: '今日消息 ({0}条)',
    trafficTips1: '是否确认开启流量？',
    trafficTips2: '开启后本月不可再关闭流量，请谨慎操作',
    trafficTips3: '若流量不足，仍需继续使用，请在【计费管理-我的账户】中充值Remote Acces计费卡并分配给本设备使用',
    trafficTips4: '本月已消耗12G流量，是否继续使用？',
    trafficTips5: '关闭流量只针对本月，下月可正常使用',
    trafficTips6: '关闭后如需继续使用流量，可在【设备管理-设备列表】中开启',
    trafficTips7: '本月流量已关闭',
    trafficTips8: '如需继续使用请在【设备列表-设备详情】开启流量',
  },

  system: {
    name: '名称',
    system: '系统管理',
    role: '角色管理',
    user: '用户管理',
    apiManage: 'API管理',
    personCenter: '个人中心',
    safeZone: '安全区',

    operations: '运营管理',
    dashboard: '数据看板',
    controlpanel: '仪表盘',
    device: '设备管理',
    billing: '计费管理',
    maintenance: '运维管理',
    message: '消息中心',

    devicelist: '设备列表',
    templatelist: '单设备模板',
    devicegroup: '设备分组',
    projectlist: '聚合项目',
    myAccount: '我的账户',
    rechargeRecord: '充值记录',
    msgBilling: '计费消息',
    firmware: '档案管理',
    relatProject: '聚合项目',

    DIACom: 'DIACom',
    DIAComTip: '开启状态时，在DIACom中可看见自己有权限的设备',

    'dashboard-view': '访问',
    'controlpanel-view': '访问',

    'devicelist-view': '访问',
    'devicelist-bind': '绑定设备',
    'devicelist-edit': '编辑',
    'devicelist-delete': '删除',
    'devicelist-hmi': '查看/操作HMI屏',
    'devicelist-hmi-check': '查看HMI屏',
    'devicelist-alloc': '分配',
    'devicelist-config': '组态画面',
    'devicelist-alarm': '告警',
    'devicelist-monitor': '数据监控',

    'templatelist-view': '访问',
    'templatelist-add': '新增模板',
    'templatelist-copy': '复制模板',
    'templatelist-edit': '新增/编辑模板',
    'templatelist-delete': '删除',
    'templatelist-data-pm': '分配权限',

    'devicegroup-view': '访问',
    'devicegroup-add': '新增分组',
    'devicegroup-edit': '编辑',
    'devicegroup-delete': '删除',
    'devicegroup-data-pm': '分配权限',

    'projectlist-view': '访问',
    'projectlist-add': '新增',
    'projectlist-edit': '编辑',
    'projectlist-delete': '删除',
    'projectlist-data-pm': '分配权限',

    'myAccount-view': '访问',
    'myAccount-ca-charge': 'Cloud Application充值',
    'myAccount-ca-allcoate': 'TAG分配',
    'myAccount-ra-charge': 'Remote Access充值',
    'myAccount-ra-allcoate': '计费卡分配',

    'rechargeRecord-view': '访问',

    'msgBilling-view': '访问',

    'firmware-view': '访问',
    'firmware-upload': '上传档案',
    'firmware-auth': '授权',
    'firmware-delete': '删除',
    'firmware-dispatch': '下发PLC',

    'user-view': '访问',
    'user-invite': '邀请用户',
    'user-edit': '变更角色',
    'user-delete': '删除',
    'user-data-pm': '数据权限',

    'role-view': '访问',
    'role-add': '新增角色',
    'role-edit': '编辑',
    'role-delete': '删除',

    'apiManage-view': '访问',
    'apiManage-add': '新建 API Key',
    'apiManage-edit': '编辑',
    'apiManage-delete': '删除',
    'apiManage-download': '下载 API 文档',
    'apiManage-reset': '重置 Secret',

    'safeZone-view': '访问',
    'safeZone-add': '新增安全区',
    'safeZone-edit': '编辑',
    'safeZone-delete': '删除',

    mainAccount: '主账号',
    subAccount: '子账号',
    teamName: '团队名称',
    team: '团队',
    modifyTeamName: '请于右上角用户下拉栏里修改团队名称',
    No: '序号',
    roleName: '角色名称',
    cannotDelete: '无法删除{0}',
    deleteRoleFirst: '请先删除该角色下所有用户，方可删除该角色!',
    isDelete: '是否删除{0}?',
    addsafeZone: '新增安全区',
    addRole: '新增角色',
    selectPmSettings: '请选择权限设置',
    enterRoleName: '请输入角色名称',
    editRole: '编辑角色',
    inviteAcceptTime: '邀请接受时间',
    multipleSelection: '可多选',
    Pmettings: '权限设置',
    menuBar: '菜单栏',
    selectAll: '全选',
    operationPm: '操作权限',
    dataPm: '数据权限',
    safeZoneInUse: '该安全区有以下角色正在使用，无法删除',
    inputAlphanumeric: '请输入[字母+数字]',
    inputAlphaNumericOnly: '只能输入[字母+数字]',
    editsafeZone: '编辑安全区',
    removeFromTeam: '是否将{0}从团队中删除',
    cancelPendingInvitations: '删除之后，该用户已发送但未被接受的邀请将会被作废',
    accountUsername: '账号/用户名',
    inviteUser: '邀请用户',
    emailAccount: '邮箱账号',
    registerAccount: '该账号未注册，请先完成账号注册',
    notCurrentDataCenterAccount: '非当前数据中心账号',
    joinedOtherTeams: '该账号已加入其他团队',
    inCurrentTeam: '该账号已在当前团队中',
    notInCurrentTeam: '该账号不在当前团队内',
    roleChange: '角色变更',
    announcement: '公告',
    startClearData: '开始清空数据',
    acceptAndReLogin: '接受并重新登陆',
    rejectInvite: '拒绝邀请',
    inviteNotification: '邀请通知',
    inviteJoinTeam1: '{0}邀请您加入{1}团队',
    dataOnAccount: '若您账号上存在设备、模板、聚合项目、计费卡等信息，建议您注册新的账号加入团队',
    unbindDevices: '账号下如有数据，需手动清空数据（解绑设备、删除模板、删除聚合项目）后方可加入团队，且数据不可恢复',
    clearDataNotice: '计费卡以及充值记录不会被清除，但个人充值卡无法带入到团队账号下并看不见充值记录',
    clearDataEffect: '清空数据之后，不影响已分配出去的TAG和流量',
    successJoinTeam: '成功加入团队后，账号权限将由主账号分配',
    reInviteIfRejected: '拒绝邀请后，如需再次加入该团队，可请邀请人重新发起邀请',
    unbindDevice: '解绑设备',
    confirmDeleteDevice1: '确定删除设备{0}?',
    confirmDeleteDevice2: '是否删除设备{0}?',
    deleteDeviceWarning: '删除该设备后，监控该设备产生的数据将被删除且不可恢复',
    invitePage: '邀请页面',
    nextStep: '下一步',
    inviteCancelled1: '该邀请已被取消',
    youRejectedInvite: '您已拒绝该邀请',
    reInviteIfNeeded: '如需加入该团队，可请邀请人重新发起邀请',
    alreadyInTeam: '您已在该团队了',
    inviteExpired: '该邀请已作废',
    reminder: '提醒',
    viewInvites: '立即查看',
    pendingInvites: '您有多条邀请通知未处理，请及时查看处理',
    inviteJoinTeam2: '{0}邀请您加入{1}团队，请确认是否接受邀请',
    inviteCancelled2: '{0}已取消邀请您加入{1}团队',
    removedFromTeam: '您已被移出团队',
    inviteBecomeMainAccount: '{0}邀请您成为{1}团队的主账号，请确认是否接受？',
    editTeamName: '编辑团队名称',
    teamNamePlaceholder: '团队名称',
    inviteSent: '邀请通知已发送，等待对方接受邀请！',
    assignRoleListPm: '请分配角色列表权限',
    assignPm: '分配权限',
    contactAdminForPm: '请联系管理员分配权限',
    close: '关闭',
    pendingInvitesAgain: '您有多条邀请通知未处理，请及时查看处理',
    userAccount: '用户账号',
    systemAdministrator: '系统管理员',
    allPm: '全部',
    platformAllPm: '拥有平台所有权限',
    setRolePm: '请设置角色权限',
    enterRoleNamePlaceholder: '请输入角色名称',
    maxTenCharacters: '最多输入10个字符',
    assignTemplateListPm: '请分配模板列表权限',
    addDataPm: '新增数据权限',
    multipleSelection2: '可多选',
    removePm: '移除权限',
    continueSending: '继续发送',
    sendBillingMessages: '当前未设置团队名称，是否继续发送邀请消息?',
    sameDataCenterAccounts: '只能邀请同一数据中心下的账号',
    access: '访问',
    cloudApplicationTopUp: 'Cloud Application充值',
    remoteAccessTopUp: 'Remote Access充值',
    noGroups: '暂无分组',
    contactAdminForPm2: '请联系系统管理员分配权限',
    uniqueTeamGroups: '团队中分组不可重复',
    loginWebToAcceptInvite: '请登录web端接受邀请',
  },
  billing: {
    billingManage: '计费管理',
    myAccount: '我的账户',
    billingOverview: '计费总览',
    rechargeRecords: '充值记录',
    cardType: '计费卡类型',
    cardNumber: '卡号',
    cardName: '计费卡名',
    cloudAppCard: 'Cloud Application',
    remoteAccessCard: 'Remote Access',
    activeOp1: '输入卡号后8位',
    activeOp2: '刮开图层，输入卡密',
    activeOp3: '打开计费卡背面',
    activating: '生效中',
    Outdated: '已失效',
    noActivated: '未激活',
    activeDate: '激活日期',
    selectActiveDate: '选择激活日期',
    status: '状态',
    validityDate: '有效期',
    TagVal: 'TAG有效期',
    opAccount: '操作账号',
    deviceLevel: '设备当前等级',
    deviceNowTag: '设备当前TAG（已使用/总数 • 个）',
    allocateDevice: '分配设备',
    allocateDate: '分配时间',
    selectAllocateDate: '选择分配时间',
    allocateLevel: '分配等级',
    allocateTagNum: '分配TAG数',
    allocateTagStatus: '分配TAG状态',
    allocateTagVal: '分配TAG有效期',
    allocateCard: '分配计费卡',
    sTagNum: '剩余TAG',
    sTemplateNum: '剩余模板',
    platformGifts: '平台赠送',
    rechargeNow: '立即充值',
    total: '总数',
    unit: '个',
    unit2: '张',
    used: '已使用',
    left: '剩余',
    tagAllocate: 'TAG分配',
    cardAllocate: '计费卡分配',
    allocateTips1: '请将{0}分配给设备使用',
    allocateTips2: '请注意{0}有效期，以免未使用的{0}过期，造成资源浪费',
    allocateTips3: '分配给设备的{0}将始终使用于被分配设备，直到{0}过期',
    viewAll: '查看详情',
    template: '模板',
    cardUseAla: '计费卡使用分析',
    num: '数量',
    notSet: '暂不分配等级',
    keepNowLevel: '保持设备当前等级',
    allocateTips: 'TAG数量 {0} 个 / 采集频率 {1} 分钟',
    level: '等级',
    CollFrequency: '采集频率',
    Minutes: '分钟',
    tagNumber: 'TAG数量',
    month: '月',
    year: '年',
    deviceDetail: '设备详情',
    returnTag: '返回TAG分配',
    returnDetail: '返回TAG详情',
    deviceUnbind: '设备已解绑本账号',
    notThisAccount: '非本账号充值',
    levelDesc: '等级说明',
    allocateTips4: '● 平台赠送的TAG分配等级只能选择{0}',
    allocateTips5: '● TAG分配规则 (采集频率按当前等级为准) ',
    allocateTips6: '分配等级仅支持升级，不支持降级',
    allocateTips7: '设备绑定账号改变，之前绑定账号给设备分配的未过期{0}，将始终跟着设备',
    allocateTips8: '未失效流量将始终跟着设备',
    optionalRange: '可选范围',
    unallocated: '待分配',
    nowAllocateTagNum: '当前可分配TAG数量',
    avaleBalance: '可用余额',
    CurrAllocate: '本次分配',
    allCardNum: '总张数',
    activedCardNum: '生效中',
    deactivedCardNum: '已失效',
    allocateSuccess: '分配成功',
    tagStatus: 'TAG 状态',
    allocatedTagStatus: '分配TAG状态',
    traffic: '流量',
    trafficCard: '流量卡',
    trafficTips: '流量使用提醒',
    billcardPackage: '计费卡套餐',
    billcardActive: '计费卡激活',
    dataStorage: '数据存储',
    validityPeriod: '有效期',
    dataCollFrequency: '数据采集频率',
    templateNum: '模板数量',
    pleaseInput: '请输入',
    pleaseSelect: '请选择',
    numTip: '请输入卡号',
    passwordTip: '请输入卡密',
    InputEnAndNum8: '请输入8位英文与数字',
    InputEnAndNum16: '请输入8位英文与数字',
    activedTips: '温馨提示',
    activedTips1: '计费卡成功激活后立即生效，有效期1年',
    activedTips2: '请在有效期内使用卡内套餐',
    cardNum: '卡号',
    cardPassword: '卡密',
    InputPassword: '请输入8位卡密',
    InputNum: '请输入卡号后8位',
    successTip: '您的计费卡已成功激活',
    cardValidityDate: '计费卡有效期',
    successTip2: '请在有效期内使用卡内套餐',
    failTip: '你的计费卡激活失败',
    failReasonTip: '激活失败原因',
    next: '下一步',
    activeNow: '立即激活',
    gotIt: '知道了',
    actived: '生效中',
    deActived: '已失效',
    tagMessage: 'TAG余额不足，无法继续分配，请使用Cloud Application计费卡充值。',
    action: '立即充值',
    know: '我知道了',
    description1: '点击立即充值后，自动确认本页面设置',
    cloudApplication: 'Cloud Application',
    remoteAccess: 'Remote Access',

    vncTips1: 'VNC使用中，该功能会根据实际使用情况扣除流量，请合理使用！',
    disabledTemplates: '当前有{0}个模板TAG无法使用',
    tagInfo: 'TAG 信息',
    requirements1: '要保证所有模板TAG都可使用',
    requirements2: '需满足设备TAG数≥模板TAG数',
    deviceTagCount: '设备可用TAG数',
    templateTagCount: '模板TAG数',
    vncTips2: '查看HMI屏，需根据实际使用扣除对应流量，请确认是否继续？',
    vncEnd: 'VNC 使用结束',
    timeLimitReached: '您设置了VNC使用时长上限，时间已到，VNC自动关闭。',
    vncTimeSetting: 'HMI屏观看时长设置',
    instruction: '当达到开启时长上限，将自动关闭VNC服务',
    tagAction: '设置时长上限',
    // trafficTips1: "该设备流量不足，如需继续使用，请前往DIACloud云平台使用Remote Access 计费卡充值。",
    trafficTips1: '该设备流量不足，如需继续使用，请使用Remote Access 计费卡充值。',
    trafficTips2: '目前设备流量不足，请避免再使用流量相关传输服务。',
    trafficTips3: '设备使用流量统计，请前往DIACloud 云平台【计费管理-账单】查看',
    trafficTips4: '该设备已被删除',
    trafficTips5: 'VNC使用结束，该设备流量不足',

    selectCardType: '请选择卡规格',
    trafficTips6: '未分配的Remote Access，可在{0}进行分配设备',
    myCount: '我的账户-计费卡分配',
    activate: '激活',
    trafficTips7: '卡内套餐需分配到设备后才能使用，请在有效期内使用该套餐',
    notAllocate: '暂不分配',
    billingCard: '计费卡',
    trafficTips8: '设备一经分配不可修改',
    trafficTips9: '请谨慎操作',
    trafficTips10: '设备优先使用即将到期的流量卡',
    confirmAllocationTips: '是否确认把该套餐分配给{0}？',
    confirmAllocation: '确认分配',
    trafficPeriod: '流量有效期',
    billingCardTraffic: '计费卡流量',
    trafficTotal: '总流量',
    trafficUsed: '已使用流量',
    trafficLeft: '剩余流量',
    trafficStatus: '剩余流量状态',
    trafficLeftCard: '卡剩余流量',
    trafficLeftDevice: '设备剩余流量',
    billingCardUsage: '计费卡使用分析',
    trafficStatistics: '未失效的流量统计',
    trafficsLeftValid: '未失效的剩余流量',
    trafficsLeftTotal: '未失效的总流量',
    selectDateActive: '选择激活日期',
    selectDateUsedMin: '选择使用日期',
    selectDateUsedMax: '选择使用日期',
    DateofUse: '使用日期',
    trafficUsed2: '使用流量',
    trafficUsage: '流量消耗详情',

    freeDongle: 'Dongle赠送',
    freeHMI: '人机赠送',
    annualCard: '年卡',
    lifetimeCard: '终身卡',
  },

  alarm: {
    devOrAlarmName: '设备名称/告警名称',
    alarmName: '告警名称',
    alarmGroup: '告警分组',
    alarmLevel: '告警等级',
    alarmType: '告警类型',
    tagName: 'TAG名称',
    alarmValue: '告警值',
    alarmTarget: '目标值',
    alarmRule: '偏差值',
    alarmContent: '告警内容',
    // alarmEnable: "告警开关",

    alarmGroupMange: '管理告警分组',

    alarmCondition: '告警条件',
    alarmState: '告警状态',
    alarmTime: '告警时间',
    responseTime: '应答时间',
    recoveryTime: '恢复时间',
    resUser: '应答人',

    minor: '轻微',
    mild: '较轻',
    moderate: '一般',
    severe: '较重',
    critical: '严重',
    HighHigh: '较高',
    High: '高',
    Low: '低',
    LowLow: '较低',
    LargeDeviation: '大偏差',
    SmallDeviation: '小偏差',
    off: '关',
    on: '开',

    alarm: '报警',
    response: '应答',
    recovery: '恢复',

    add: '新增',
    repeat: '告警名称不允许重复',
    onOffTip: '告警类型为开关时，告警值只能输入0,1',
    onTip: '告警类型为开时，告警值只能输入1',
    OffTip: '告警类型为关时，告警值只能输入0',
    deviation: '越限告警',
    limit: '偏差告警',
    onOff: '开关告警',

    selectTag: '选择TAG',
    errTips1: '{0}未填写',
    errTips2: '{0}不存在',
    errTips3: '告警类型为{0}的TAG类型不可以是String和Bool',
    errTips4: '告警类型为{0}的TAG类型只能是Bool',
    addAlarm: '新增告警',
    editAlarm: '修改告警',
    when: '当',
    state: '状态',
    errRes: '失败原因',
    import: '导入',
    export: '导出',
    importErr: '数据导入失败',
    errMsg1: '下载错误报告并按照提示修改信息后再次上传',
    downloadErr: '下载错误报告',
    clickUpload: '点击上传',
    importRule: '导入规则',
    importMsg: '请按照模板格式填写信息',
    importMsg2: '将文件拖拽到此处，或',
    importMsg3: '支持 xls、xlsx 格式',
    importMsg4: '最多支持导入300条数据',
    importMsg5: '至多只能导出10000条数据',
    importMsg6: '当告警名称与平台已有的名称相同时，更新导入的告警规则',
    downloadTem: '下载模板',
    importComplate: '数据导入完成',
    fileName: '文件名称',
    dataNum: '数据总量',
    importOK: '成功导入',
    importTime: '导入时间',
    selectToRes: '勾选应答',
    uploadAgain: '重新上传',
    goList: '返回列表',
    selectAlarmType: '请先选择告警类型',
    typeErr: '上传的文件格式不正确，请上传Excel文件',
    goAlarmMsg: '查看全部并处理告警',
    fileTypeErr: '导入文件格式不正确',
    fullText: '全文',
    notMatch1: '输入的告警值与TAG类型不匹配',
    notMatch2: '偏差值格式不正确',
    notMatch3: '目标值格式不正确',
    tagInvalid: '找不到TAG ID',
  },
  monitor: {
    piCharacters: '请输入1-255个字符',
    dataMonitor: '数据监控',
    startCollect: '开始采集',
    stopCollect: '停止采集',
    collectionConfig: '采集配置',
    addMonitor: '新增监控',
    copyMonitor: '复制监控',
    batchOperations: '批量操作',
    batchAdd: '批量新增',
    batchDelete: '批量删除',
    moreOperation: '更多操作',
    monitorName: '监控名称',
    value: '数值',
    match: '匹配',
    mismatch: '不匹配',
    configStatus: '配置状态',
    description: '描述',
    address: '地址',
    collectFrequence: '采集频率',
    opertaion: '操作',
    collectConfirmMsg: '设备开始采集数据，会根据实际情况扣除流量，请合理使用',
    collectQuitMsg: '退出界面默认停止数据采集',
    saverMode: '省流模式配置',
    saverMsg: '适用所有TAG',
    type: '数据类型',
    selectType: '请先选择数据类型',
    nameValidMsg: '请输入监控名称',
    typeValidMsg: '请选择数据类型',
    sizeValidMsg: '请输入长度',
    decimaValidMsg: '请输入小数位数',
    stepValidMsg: '请输入增量',
    batchNumValidMsg: '请输入增量个数',
    selectAddressPs: '请选择地址',
    link: '联机类型',
    plcManufacturer: 'PLC厂商',
    plcName: 'PLC名称',
    model: '型式',
    station: '站号',
    defaultValue: '默认值',
    componentType: '组件种类',
    addressValue: '地址(数值)',
    linkValidMsg: '请选择联机类型',
    plcFacValidMsg: '未选择PLC厂商',
    plcNameValidMsg: '未选择PLC名称 ',
    stationValidMsg: '请输入站号',
    componentValidMsg: '请选择组件种类',
    addressValidMsg: '请输入地址',
    decimal: '小数位数',
    size: '输入长度',
    step: '增量',
    batchNum: '批量个数',
    uploadLimitMsg: '最多支持导入{0}个监控',
    monitorDeleteConfirm: '确认删除监控',
    monitorDeleteSelectedConfirm: '确认删除选中监控',
    uploadNameRule: '当监控名称与平台已有的名称相同时，更新导入的监控配置',
    monitorNameNoRepeat: '监控名称不可重复',
    internalMemory: '内部寄存器',
    component: '组件',
    constant: '常数',
    importMonitor: '导入监控',
    collectFail: '采集下发失败',
    deleteMismatch: '删除不匹配的监控',
    keepCollect: '继续采集',
    configStatusInfo: '匹配监控的配置信息与设备实际的配置信息',
    editMonitor: '编辑监控',
    selectAddress: '选择地址',
    addSuccessMsg1: '新增{0}类型的监控成功',
    configSaveSuccessMsg: '配置保存成功',
    configSaveFailMsg: '配置保存失败',
    monitorEmptyInfo1: '开始创建你的数据监控看板',
    sizeValidMsg2: '支持大于等于0的整数',
    sizeValidMsg3: '输入的长度为大于等于0的整数',
    sizeValidMsg4: '支持大于等于1的整数',
    decimaValidMsg2: '支持整数0-6',
    decimaValidMsg3: '支持整数0-14',
    batchNumValidMsg2: '支持整数2-{0}',
    nameValidMsg2: '只允许输入1-255个字符',
    typeValidMsg2: '请输入正确的数据类型',
    stationValidMsg2: '输入的站号为大于等于0的整数',
    plsSelectMonitor: '请选择要删除的监控',
    collectErrorMsg1: '采集下发失败！存在不匹配的监控配置',
    // excel模板字段
    template: {
      name: '名称',
      type: '数据类型',
      decimal: '小数点位',
      size: '长度',
      linkType: '联机类型',
      station: '站号',
      componentType: '组件种类',
      addressNum: '地址（数值）',
      desc: '描述',
      collectFail: '采集失败',
    },
    gathertip: '采集中断，请重新开始采集',
    didEmpty: '请先让设备上线',
  },
  history: {
    time: '时间',
    historyData: '历史数据',
    lastest: '最近',
    minute: '分钟',
    hour: '小时',
    day: '天',
    week: '周',
    month: '月',
    year: '年',
    ascend: '升序',
    descend: '降序',
    selectTAG: '选择TAG',
    enableTAG: '启用TAG',
    timeDistance: '时间区间',
    timeInterval: '时间间隔',
    row: '行',
    selectTagLimit: '最多选择{0}个',
    define: '自定义',
    hasChoose: '已选择',
    selectTagHint: '选择TAG，可查看历史数据',
    goSelectTag: '去选择TAG',
    step1: '1、请先让设备上线',
    step2: '2、设备需绑定模版',
    step3: '3、设备绑定的模板需要有存历史数据的数值型TAG',
  },
  ERR_FR_TOO_MANY_REDIRECTS: '太多重定向',
  ERR_BAD_OPTION_VALUE: '无效的参数值',
  ERR_BAD_OPTION: '无效的参数',
  ERR_NETWORK: '网络错误',
  ERR_DEPRECATED: '已弃用',
  ERR_BAD_RESPONSE: '响应错误',
  ERR_BAD_REQUEST: '请求错误',
  ERR_NOT_SUPPORT: '不支持',
  ERR_INVALID_URL: '无效的 URL',
  ERR_CANCELED: '请求已取消',
  ECONNABORTED: '请求超时或被中止',
  ETIMEDOUT: '请求超时',
  ERR_EMAIL_EXIST: '邮箱已存在',
  E_INVALID_PARAM_DID: '无效设备ID',
  E_INVALID_DEVICEID: '无效设备ID',
  E_INVALID_ID: '无效ID',
  E_GET_DEV_GROUP_DETAIL_ERR: '获取设备详情失败',
  E_USER_NOT_FOUNT: '未找到该用户',
  E_DEVICE_VNC_OFFLINE: '设备VNC已离线',
  E_MISSING_AUTH_HEADER: 'TOKEN请求头丢失',
  E_TEMPLATE_CAN_NOT_DEL_WITH_BIND_DEV: '该模板已绑定设备',
  E_INVALID_PASSWD: '密码错误',
  E_INPUT_PWD_ERR: '密码输入错误',
  E_INVALID_OR_EXPIRED_TOKEN: '登录已过期, 请重新登录!',
  E_USER_NOT_FOUND: '用户不存在',
  ERR_PHONE_NOT_VERIFY: '验证码错误',
  ERR_ACCOUNT_EXIST: '账号已存在',
  ERR_EMAIL_NOT_ACTIVE: '邮箱未激活',
  E_BILLING_TAG_RECORD_FOUND: '卡号或卡密错误，请检查您的卡号或卡密',
  E_CLOUD_CARD_PWD_ERR: '卡号或卡密错误，请检查您的卡号或卡密',
  E_BILLING_REMOTE_ACCESS_RECORD_FOUND: '卡号或卡密错误，请检查您的卡号或卡密',
  E_CLOUD_CARD_ALREADY_ACTIVATE: '该计费卡已被激活，请勿重复激活',
  E_SAFEAREAS_NAME_EXIST: '安全区名称已存在',
  E_SAFEAREAS_MORE_THAN_LIMIT: '最多添加20个安全区',
  E_hdd_team_group_name_exist: '团队中分组不可重复',
  E_MONITOR_TAG_NAME_EXIST: '监控名称不可重复',
  E_MONITOR_TAG_NUM_LIMIT: 'TAG数量超出限制',
  E_DEV_OFFLINE: '该设备已离线',
  E_PARAM_NAME_INVALID: '参数错误请检查',
  E_PARAM_DESC_TOO_LONG: '描述长度超出限制',
  E_VALUE_OUT_OF_VALID_RANGE: '输入超出范围',
  E_PLC_VALUE_RANGE_INVALID: '地址数据输入无效',
  E_LINK_NAME_NOT_EXIST: 'Link名称输入无效',

  '1003_1': '设备已解绑，请编辑重新选择设备',
  '1001': '认证错误',
  '1002': '权限不足',
  '1003': '暂无数据',
  '1004': '密码错误',
  '1005': '数据库错误',
  '1006': '输入参数错误',
  '1007': '服务器内部异常',
  '1008': 'Auth Header缺失',
  '1009': '登录过期 请重新登录',
  '1010': '用户未找到',
  '1011': '验证码错误',
  '1012': '用户已存在',
  '1013': '邮件发送失败',
  '1014': '请到注册邮箱激活您的账号',
  '1015': '邮件达到限制',
  '1016': '手机号未验证',
  '1017': '需要重新获取手机验证码',
  '1018': '验证码发生失败',
  '1019': '账号不匹配 (资源的账号不匹配)',
  '1020': '邮箱激活链接过期 需要重新注册',
  '1021': '参数错误',
  '1022': '验证码已过期',
  '1023': '未找到当前客户端的Session 信息  重新发送RAND',
  '1024': '请至HMI开启VNC',
  '1025': '非法Pin',
  '1026': '非法的Licnese',
  '1027': '非法的设备分组ID',
  '1028': '非法的HMISN',
  '1029': '非法的模板ID',
  '1030': '模板名称已存在',
  '1031': '邮箱未验证',
  '1032': '该分组或其子分组存在设备，不可删除',
  '1033': '模板数量已达上限',
  '1034': '设备名称已存在',
  '1037': '该模板存在关联设备，不可删除',
  '1038': '设备不在线',
  '1042': '切换模板时与新模板的模板类型不匹配',
  '1043': '卡号或卡密错误，请检查您的卡号或卡密',
  '1044': '计费卡已经过了允许的激活时间',
  '1045': '该计费卡已被激活，请勿重复激活',
  '1050': '该计费卡已被激活，请勿重复激活',
  '1055': '账号已注销',
  '1063': '角色名称重复',
  '1065': '最多添加20个安全区',
  '1066': '安全区名称已存在',
  '1069': '该账号已加入其他团队',
  '1071': '该账号不在当前团队内',
  '1078': '非当前数据中心账号',
  '1085': '告警分组名称已存在',
  '1086': '名称已存在',
  '1087': '邀请时输入的聚合项目id不属于当前用户',
  '1088': '告警名称已存在',
  '1083': '团队中分组不可重复',
  '1090': '告警规则至多只能设置300个规则',
  '1091': '当前设备已被组态引用，如需移除设备，请先前往DIAWebDesigner中取消绑定',
  '1100': 'TAG数量超出限制',
  '2001': '解析DIAView Tar包异常',
  '2003': '网络错误',

  '1035': '历史数据查询数量达到上限',
  '1036': '请求太频繁 请稍等',
  '1039': '不合法的Dongle SN',
  '1040': 'Refresh  Token 过期',
  '1041': '请更新最新云端的Tag至本地',
  '1046': '流量不足',
  '1047': 'vln vnc headbeat 流量达到12G 时 用户未确认是否继续使用',
  '1048': 'setvln / hb  enable 流量达到12 G 后用户确认本月不继续使用',
  '1049': '密码错误',
  '1051': '超出可激活时间',
  '1052': '模板已经锁住',
  '1053': '账号下的设备不为空',
  '1054': '账号下的模板不为空',
  '1056': 'Remote Access 卡已经被分配了',
  '1057': 'Remote Access 状态已过期',
  '1058': 'DIACloud 1.0平台的子账号数量不为0',
  '1059': 'DIACloud 1.0平台的子账号下不支持注销',
  '1060': 'DIACloud 1.0平台的设备数量不为0',
  '1062': '角色不属于该用户',
  '1064': '邀请邮件发送失败',
  '1067': '安全区正在被使用',
  '1070': '邀请短信发送失败',
  '1072': '该角色正在被使用',
  '1073': '邀请发起人已离开该团队',
  '1074': '用户取消了邀请',
  '1075': '用户未接受邀请',
  '1076': '该用户已加入团队',
  '1077': '不能把主账号移出团队',
  '1079': '邀请时输入的模板id 不属于当前用户',
  '1080': '邀请时输入的分组id 不属于当前用户',
  '1081': '不能给主账号分配数据权限',
  '1082': '该邀请已作废',
  '1084': '该用户已加入团队',
  '1089': '该设备未加入当前聚合项目',
  '1092': '存在聚合项目',
  '1093': '非法地址',
  '1094': '创建DiaScreen lib 实例失败',
  '1095': '获取bit列表失败',
  '1096': '检测plc地址范围失败',
  '1097': '获取word列表失败',
  '1098': '获取组件列表失败',
  '1099': '获取plc下一个地址失败',
  '1101': '获取plc默认账号失败',
  '1102': '当前hmisn 已经绑定过了',
  '1104': '当前数据中心无当前账号数据',
  '1105': '子账号无法新增数据中心',
  '1106': '该账号已加入其他团队',
  '2002': 'settag失败,因为设备端的模板id 未同步',
  '2011': '档案文件超过大小限制',
  '2012': '档案文件类型不支持',
  '2013': '固件档案不存在',
  '2014': '固件档案不属于当前团队',
  '2015': '固件档案授权不存在',
  '2016': '固件档案授权已存在',
  '2017': '固件档案授权下载次数已达上限',
  '2018': '固件档案任务状态不允许上报',
  '2019': '固件档案任务与上报参数不匹配',
  '2020': '固件档案ID非法',
  '2021': '同一团队内固件档案名称已存在',
  E_ARCHIVE_FILE_TOO_LARGE: '档案文件超过大小限制',
  E_ARCHIVE_UNSUPPORTED_FILE_TYPE: '档案文件类型不支持',
  E_ARCHIVE_FIRMWARE_NOT_FOUND: '固件档案不存在',
  E_ARCHIVE_FIRMWARE_NOT_IN_TEAM: '固件档案不属于当前团队',
  E_ARCHIVE_AUTH_NOT_FOUND: '固件档案授权不存在',
  E_ARCHIVE_AUTH_ALREADY_EXISTS: '固件档案授权已存在',
  E_ARCHIVE_DOWNLOAD_LIMIT_REACHED: '固件档案授权下载次数已达上限',
  E_ARCHIVE_TASK_NOT_READY_FOR_REPORT: '固件档案任务状态不允许上报',
  E_ARCHIVE_TASK_NOT_MATCH: '固件档案任务与上报参数不匹配',
  E_ARCHIVE_FIRMWARE_ID_INVALID: '固件档案ID非法',
  E_ARCHIVE_FIRMWARE_NAME_EXISTS: '同一团队内固件档案名称已存在',
  apiManage: {
    credentials: 'API Key',
    logs: '调用日志',
    statistics: '调用量统计',
    apiKey: 'API Key',
    applicationName: '应用名称',
    status: '状态',
    permissions: '接口权限',
    dataScope: '数据范围',
    validity: '有效期',
    updatedBy: '更新人',
    updatedAt: '更新时间',
    lastUsedAt: '最后调用',
    endpoint: '接口',
    method: '方法',
    sourceIp: '来源 IP',
    statusCode: '状态码',
    requestedAt: '调用时间',
    totalCalls: '总调用量',
    todayCalls: '今日调用',
    successCalls: '成功调用',
    failedCalls: '失败调用',
    successRate: '成功率',
    all: '全部',
    enabled: '启用',
    disabled: '停用',
    expired: '已过期',
    createCredential: '新建 API Key',
    editCredential: '编辑 API Key',
    searchCredential: '搜索应用名称 / API Key',
    searchApplication: '搜索应用名称',
    copyKey: '复制 API Key',
    copied: '已复制',
    downloadDocument: '下载 API 文档',
    resetSecret: '重置 Secret',
    secretUnavailableAfterClose: '请复制并妥善保存 API Key 与 Secret，关闭后 Secret 将无法再次查看。',
    copyAndClose: '复制并关闭',
    resetSecretTip: '重置后旧 Secret 将失效，请确认调用方已准备更新。',
    confirmEnable: '启用 API Key',
    confirmDisable: '停用 API Key',
    statusChangeTip: '{0} 的调用状态将发生变化，是否确认？',
    expiredCredentialTip: 'API Key 已过期，请先延长有效期。',
    deleteCredentialTip: '删除后 {0} 将无法继续调用 API。',
    applicationNamePlaceholder: '请输入应用名称',
    selectPermissions: '请选择接口权限',
    completeRequiredFields: '请完成必填项配置',
    selectScopeValues: '请配置数据范围',
    scopePermissionDenied: '权限不足',
    ipWhitelist: 'IP 白名单',
    ipWhitelistPlaceholder: '一行一个 IP；留空表示暂不限制',
    ipWhitelistInvalid: 'IP 白名单格式不正确',
    allData: '全部数据',
    specifiedDevice: '指定设备',
    specifiedGroup: '指定分组',
    specifiedTemplate: '指定模板',
    validityDays: '{0}天',
    productionEnvironment: '客户生产环境',
    thirdPartyDashboard: '第三方看板测试',
    defaultOperator: '系统管理员',
    documentTitle: 'DIACloud Open API 文档',
    generatedAt: '生成时间',
    deviceRead: '设备基础数据',
    telemetryRead: '实时点位数据',
    telemetryWrite: '点位数据操作',
    historyRead: '历史数据',
    alarmRead: '告警查询',
    alarmWrite: '告警处理回写',
    deviceReadDescription: '设备基础信息',
    telemetryReadDescription: '实时点位数据',
    telemetryWriteDescription: '点位写入与控制',
    historyReadDescription: '历史数据查询',
    alarmReadDescription: '告警查询',
    alarmWriteDescription: '告警处理回写',
    defaultGroup: '默认分组',
    productionLine: '产线分组',
    productionTemplate: '产线模板',
    energyTemplate: '能耗模板',
  },
  firmware: {
    firmware: '档案',
    plcName: '档案名称',
    version: '版本号',
    fileName: '文件名',
    fileSize: '文件大小',
    md5: 'MD5',
    type: '类型',
    uploadTime: '创建时间',
    operator: '创建人',
    authorizer: '操作人',
    uploadFirmware: '上传档案',
    uploadTip: '点击或拖拽上传档案文件，支持多选',
    uploadFormat: '支持格式',
    fileTypeError: '只允许上传 .isp、.dvp、.diaobj 或 .inivals 格式的文件',
    fileSizeLimit: '文件总大小不能超过 50 MB',
    pleaseSelectFile: '请选择文件',
    pleaseInputPlcName: '请输入档案名称',
    pleaseInputVersion: '请输入版本号',
    plcNamePlaceholder: '请输入档案名称',
    versionPlaceholder: '请输入版本号',
    uploadSuccess: '上传成功',
    uploadFailed: '上传失败',
    authorize: '授权',
    authorizeFirmware: '档案授权',
    firmwareName: '档案名称',
    selectAccount: '选择账号',
    downloadLimit: '下发次数',
    downloadLimitPlaceholder: '请输入下发次数',
    isAuthorized: '是否授权',
    filterAuthorized: '是否授权',
    authorizedAccount: '授权账号',
    authorizeTime: '操作时间',
    authorizeInfo: '授权信息',
    authorizeDetail: '授权详情',
    downloadCount: '授权次数',
    pleaseSelectAccount: '请选择账号',
    pleaseInputDownloadLimit: '请输入授权次数',
    authorizeSuccess: '授权成功',
    downloadLimitReached: '下发次数已达上限',
    downloadStart: '正在下载',
    downloadSuccess: '下载完成',
    deleteConfirm: '确认删除该档案吗？',
    deleteSuccess: '删除成功',
    authorizeGuide: '档案上传成功，是否立即授权给用户？',
    goAuthorize: '去授权',
    skipAuthorize: '暂不授权',
    accountsAuthorized: '个账号已授权',
    authorizeRecords: '授权记录',
    noAuthRecords: '暂无授权记录',
    deleteFirmware: '确认删除该档案',
    userAccount: '账号',
    pleaseInputAccount: '请输入账号',
    accountPlaceholder: '请输入账号，多个账号用逗号分隔',
    plcNameSearch: '档案名称搜索',
    dispatchRecords: '下发记录',
    hmiDispatchCountTip: 'HMI成功下发程序到PLC算一次',
    noDispatchRecords: '暂无下发记录',
    archiveType: '档案类型',
    pleaseSelectArchiveType: '请选择档案类型',
    deviceId: '设备ID',
    deviceName: '设备名',
    limitCount: '限制次数',
    noLimit: '不限制',
    hmiDispatchTip: 'HMI成功下发程序到PLC',
  },
  sim: {
    simInfo: 'SIM卡信息',
    inUse: '使用中',
    rechargeRecord: '充值记录',
    packageName: '套餐名称',
    effectiveTime: '生效时间',
    expireTime: '到期时间',
    monthUsedTraffic: '本月已用流量',
    monthRemainTraffic: '本月剩余流量',
    packageUpgrade: '套餐升级',
    packageRenew: '套餐续费',
  },
}
